// src/pages/RoleSelect.jsx
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    getRoles,
    getActiveRole,
    setActiveRole,
    targetPathForRole,
    isAuthenticated,
} from '../utils/auth';

const RoleSelect = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        if (!isAuthenticated()) {
            navigate('/login', { replace: true });
            return;
        }

        const list = getRoles();
        setRoles(list);

        const alreadyActive = getActiveRole();
        if (alreadyActive) {
            navigate(targetPathForRole(alreadyActive), { replace: true });
            return;
        }

        if (list.length === 1) {
            setActiveRole(list[0]);
            navigate(targetPathForRole(list[0]), { replace: true });
        }
    }, [navigate]);

    const choose = (role) => {
        setActiveRole(role);
        const from = location.state?.from?.pathname;
        navigate(from || targetPathForRole(role), { replace: true });
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="w-full max-w-md mx-4">
                <div className="bg-white rounded-lg shadow-md p-8">
                    <h1 className="text-2xl font-bold text-gray-900 text-center mb-6">{t('roleSelect.title')}</h1>

                    {roles.length === 0 ? (
                        <div className="text-center py-6">
                            <p className="text-gray-600 mb-2">{t('roleSelect.noRoles')}</p>
                            <p className="text-sm text-gray-500">{t('roleSelect.contactAdmin')}</p>
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {roles.map((r) => (
                                <button
                                    key={r}
                                    onClick={() => choose(r)}
                                    className="w-full py-4 px-6 bg-white border-2 border-gray-300 rounded-lg text-lg font-medium text-gray-900 hover:border-purple-500 hover:bg-purple-50 hover:text-purple-700 transition-all duration-200"
                                >
                                    {t(`faq.roles.${r}`, { defaultValue: r })}
                                </button>
                            ))}
                        </div>
                    )}

                    <p className="text-sm text-gray-500 text-center mt-6">
                        {t('roleSelect.switchHint')}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RoleSelect;
